<!-- industry-configuration.component.html -->
<div class="mt-4 mx-4">

    <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>

    <!-- Page Header -->
    <div class="page-header-bar card shadow-sm border-0 mb-3">
        <div class="card-body d-flex align-items-center justify-content-between flex-wrap gap-2 py-3">
            <div class="d-flex align-items-center gap-3">
                <div class="header-icon-wrap">
                    <i class="bi bi-building-fill-gear"></i>
                </div>
                <div>
                    <h5 class="mb-0 fw-bold page-title">Industry Configuration</h5>
                    <small class="text-muted">Manage active industry types</small>
                </div>
            </div>
            <button *ngIf="authService.hasAccess('configuration.industryConfiguration', 'Add')"
                class="btn add-config-btn d-flex align-items-center gap-2" (click)="openAddForm()">
                <i class="bi bi-plus-lg"></i>
                Add Industry
            </button>
        </div>
    </div>

    <!-- Table Card -->
    <div class="card shadow-sm border-0">
        <div class="card-body">

            <!-- Search bar -->
            <div class="mb-3">
                <div class="position-relative">
                    <input type="text" class="form-control ic-search-input shadow-none" placeholder="Type here..."
                        [(ngModel)]="searchText" (input)="performSearch()" />
                    <span class="search-icon">
                        <i class="bi bi-search"></i>
                    </span>
                </div>
            </div>

            <!-- Empty state -->
            <div *ngIf="!isLoading && filteredIndustries.length === 0" class="text-center py-5">
                <i class="bi bi-inbox fs-1 text-muted mb-3"></i>
                <p class="text-muted mb-0">No industry types found.</p>
                <small class="text-muted">Try a different search term or add a new entry.</small>
            </div>

            <!-- Table -->
            <div *ngIf="!isLoading && filteredIndustries.length > 0" class="ic-table-card">
                <div class="table-responsive">
                    <table class="ic-table">
                        <colgroup>
                            <col class="ic-col-id">
                            <col class="ic-col-desc">
                            <col class="ic-col-status">
                            <col class="ic-col-act">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Description</th>
                                <th class="text-center">Status</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of pagedIndustries">
                                <td>
                                    <span class="ic-id-pill">#{{ item.industryTypeId }}</span>
                                </td>
                                <td>{{ item.industryDescription }}</td>
                                <td class="text-center">
                                    <span class="badge" [ngClass]="item.isActive ? 'badge-active' : 'badge-inactive'">
                                        {{ item.isActive ? 'Active' : 'Inactive' }}
                                    </span>
                                </td>
                                <td>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <button
                                            *ngIf="authService.hasAccess('configuration.industryConfiguration', 'Edit')"
                                            class="btn action-btn-edit p-0" title="Edit" (click)="openEditForm(item)">
                                            <i class="bi bi-pencil-square"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Paginator -->
                <div class="ic-table-footer">
                    <app-paginator [serverSide]="true" [totalItems]="totalIndustries" [pageSize]="pageSize"
                        [pageSizeOptions]="[5, 10, 20, 50]" [activePage]="currentPage" (pageChangeServer)="onPageChange($event)">
                    </app-paginator>
                </div>
            </div>

        </div>
    </div>
</div>

<!-- ═══════════════════════════════════════════════════════════════ -->
<!-- Add / Edit Offcanvas                                           -->
<!-- ═══════════════════════════════════════════════════════════════ -->
<div #industryOffcanvasEl class="offcanvas offcanvas-end ic-offcanvas" tabindex="-1" id="industryOffcanvas"
    aria-labelledby="industryOffcanvasLabel">

    <div class="offcanvas-header">
        <div class="d-flex align-items-center gap-3">
            <div class="offcanvas-icon-wrap">
                <i class="bi" [ngClass]="mode === 'add' ? 'bi-plus-circle' : 'bi-pencil-square'"></i>
            </div>
            <div>
                <h5 class="offcanvas-title mb-0" id="industryOffcanvasLabel">
                    {{ mode === 'add' ? 'Add Industry Type' : 'Edit Industry Type' }}
                </h5>
                <small class="text-muted">
                    {{ mode === 'add' ? 'Fill in the details below' : 'Update the industry description' }}
                </small>
            </div>
        </div>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeOffcanvas()"></button>
    </div>

    <div class="offcanvas-body">
        <form [formGroup]="industryForm" (ngSubmit)="onSave()">

            <!-- Industry Description -->
            <div class="mb-4">
                <label class="form-label field-label">
                    Industry description <span class="text-danger">*</span>
                </label>
                <input type="text" class="form-control config-input" formControlName="industryDescription"
                    placeholder="e.g. Information Technology" maxlength="150"
                    [readonly]="selectedItem?.isActive === false"
                    [class.is-invalid]="industryForm.get('industryDescription')?.invalid && industryForm.get('industryDescription')?.touched" />
                <div class="invalid-feedback">
                    <span *ngIf="industryForm.get('industryDescription')?.errors?.['required']">
                        Industry description is required.
                    </span>
                    <span *ngIf="industryForm.get('industryDescription')?.errors?.['maxlength']">
                        Description cannot exceed 150 characters.
                    </span>
                    <span *ngIf="industryForm.get('industryDescription')?.errors?.['pattern']">
                        Only letters, spaces, and & are allowed.
                    </span>            
                </div>
            </div>

            <!-- Status (edit mode only — read-only) -->
            <div class="mb-4" *ngIf="mode === 'edit'">
                <label class="form-label field-label">Status</label>
                <div>
                    <span class="badge" [ngClass]="selectedItem?.isActive ? 'badge-active' : 'badge-inactive'">
                        {{ selectedItem?.isActive ? 'Active' : 'Inactive' }}
                    </span>
                </div>
                <!-- <small class="text-muted mt-1 d-block" style="font-size:11px">
                    Status is read-only.
                </small> -->
            </div>

            <!-- Footer -->
            <div class="d-flex gap-2 justify-content-end mt-5 pt-3 border-top">
                <button type="button" class="btn btn-cancel" (click)="closeOffcanvas()" [disabled]="isSaving">
                    Cancel
                </button>
                <button type="submit" class="btn btn-save d-flex align-items-center gap-2"
                    [disabled]="isSaving || industryForm.invalid || selectedItem?.isActive === false">
                    <span *ngIf="isSaving" class="spinner-border spinner-border-sm"></span>
                    <i *ngIf="!isSaving" class="bi bi-check-lg"></i>
                    {{ isSaving ? 'Saving...' : 'Save' }}
                </button>
            </div>

        </form>
    </div>
</div>